import { Posting } from 'app/library/posting/models/posting.model';
import { ScheduledStreamContentFailedItem } from './scheduled-stream-content-bulk-failed-item.model';
import { IScheduledStreamContentBulkQuery } from '../interfaces/scheduled-stream-content-bulk.query.interface';

// @dynamic
export class MaxBrainScheduledStreamContentBulk {
    created: Posting[] = [];
    failed: ScheduledStreamContentFailedItem[] = [];

    constructor(query: IScheduledStreamContentBulkQuery) {
        this.created = query.created.map((item) => new Posting(item));
        this.failed = query.failed.map((item) => new ScheduledStreamContentFailedItem(item));
    }
}
